/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("storeGroup", () => ({
    templateUrl: "app/admin/store/group/store-group.html",
    controller: "StoreGroupCtrl",
    controllerAs: "vm",

    scope: {
      showSelectedOrganization: "=",
    },
  }))
